import * as cn from "classnames";
import * as React from "react";

export interface AutoScaleSvgProps {
    viewportWidth: number;
    viewportHeight: number;
    className?: string;
    children?: React.ReactChild | React.ReactChild[];
}

export class AutoScaleSvg extends React.Component<AutoScaleSvgProps> {
    public svg: SVGSVGElement | undefined;

    render() {
        return (
            <svg
                className={cn(this.props.className)}
                viewBox={`0 0 ${this.props.viewportWidth} ${this.props.viewportHeight}`}
                preserveAspectRatio="xMidYMid meet"
                ref={svg => this.replaceSvg(svg)}
            >
                {this.props.children}
            </svg>
        );
    }

    componentWillMount() {
        window.addEventListener("resize", this.onResizeSvg);
        this.onResizeSvg();
    }

    componentWillUnmount() {
        if (this.svg) {
            this.svg.removeEventListener("resize", this.onResizeSvg);
        }

        window.removeEventListener("resize", this.onResizeSvg);
    }

    componentWillReceiveProps() {
        this.onResizeSvg();
    }

    private replaceSvg(svg: SVGSVGElement | undefined) {
        if (this.svg) {
            this.svg.removeEventListener("resize", this.onResizeSvg);
        }

        if (svg) {
            this.svg = svg;
            this.svg.addEventListener("resize", this.onResizeSvg);
            this.onResizeSvg();

            setTimeout(() => this.onResizeSvg(), 1);
        }
    }

    private onResizeSvg = () => {
        if (this.svg) {
            const rect = this.svg.getClientRects()[0];

            if (!rect) {
                return;
            }

            const xRatio = this.props.viewportWidth / rect.width;
            const yRatio = this.props.viewportHeight / rect.height;

            const { actualSize, viewportSize } =
                xRatio < yRatio
                    ? { actualSize: rect.height, viewportSize: this.props.viewportHeight }
                    : {
                          actualSize: rect.width,
                          viewportSize: this.props.viewportWidth
                      };

            const scale = viewportSize / actualSize;

            this.svg.style.fontSize = `${scale}px`;
        }
    };
}
